import { CanvasCoordinates, CanvasRenderingCtx } from '../rendering';
import { PhotoEditorAnnotationCanvasRenderer } from './photo-editor.decorator';
import { FreeAnnotation } from './annotation';

export class FreePenRenderer implements PhotoEditorAnnotationCanvasRenderer<FreeAnnotation> {
  constructor(
    private readonly ctx: CanvasRenderingContext2D,
    public annotation: FreeAnnotation,
  ) {}

  draw(renderingCtx: CanvasRenderingCtx): void {
    this.ctx.save();

    this.ctx.lineWidth = 2;
    this.ctx.strokeStyle = this.annotation.color;

    this.ctx.beginPath();
    this.annotation.traceLine.forEach((c: CanvasCoordinates, index: number) => {
      if (index === 0) {
        this.ctx.moveTo(c.x, c.y);
      } else {
        this.ctx.lineTo(c.x, c.y);
      }
    });

    this.ctx.stroke();
    this.ctx.restore();
  }
}
